module.exports = __webpack_public_path__ + "../static/img/router-alert.fb6afd8e.png";